import { Modal } from '@codametrix/ui-components';
import { Button, Flex } from '@chakra-ui/react';
import React from 'react';
import { cmxDateTime } from '@codametrix/ui-common';

const AcceptableEula: React.FC<CMxCommonApp.EulaComponentProps> = props => {
  const {
    eula,
    context,
    optionalEulaAcceptancePayload,
    onEulaAccept,
    onEulaCancel
  } = props;

  const acceptEulaClick = () => {
    const datedEula: CMxAPI.Eula = {
      ...eula,
      acceptedDate: cmxDateTime.format(
        new Date(),
        cmxDateTime.FORMATS.DATE_TIME_EULA
      )
    };
    onEulaAccept({
      eula: datedEula,
      context: context,
      optional: optionalEulaAcceptancePayload
    });
  };
  const footerChildren = (
    <Flex alignItems="center" gap={3} justifyContent="flex-end" width="100%">
      <Button
        variant="secondary"
        className="qa-cancel-button"
        minW="72px"
        onClick={() => {
          onEulaCancel(true);
        }}
      >
        Cancel
      </Button>
      <Button
        variant="primary"
        className="qa-submit-button"
        minW="72px"
        onClick={() => {
          acceptEulaClick();
        }}
      >
        Accept
      </Button>
    </Flex>
  );

  return (
    <div className={'qa-acceptable-eula acceptable-eula'}>
      <Modal
        bodyClassName="eula-modal-body"
        className="eula-modal"
        footerChildren={footerChildren}
        closable={false}
        title={'CodaMetrix End User License Agreement'}>
        <div>{eula.text}</div>
        {/* <ReactMarkdown children={eula.text}></ReactMarkdown> */}
      </Modal>
    </div>
  );
};

AcceptableEula.displayName = 'AcceptableEula';

export default AcceptableEula;
